import React from 'react';
import { SessionRecommendationsMessage } from '../../../domain/richMessage.interface';
import { TextCard } from './TextCard';

interface SessionsCardProps {
  data: SessionRecommendationsMessage;
}

export const SessionsCard: React.FC<SessionsCardProps> = ({ data }) => (
  <div>
    <TextCard message={data.text} />
    <p className="text-coral text-xs font-bold uppercase tracking-widest mt-3 mb-2 px-1">
      RECOMMENDED AT 11TH ANNUAL BECKER'S IT + REVENUE CYCLE CONFERENCE
    </p>
    <div className="flex flex-col gap-2">
      {data.sessions.map((session, i) => (
        <div key={i} className="bg-grey-96 rounded-xl p-3">
          <span className="inline-block bg-azure-88 text-navy text-[10px] font-bold uppercase px-2 py-0.5 rounded-pill mb-1">
            {session.time} · {session.location}
          </span>
          <p className="text-navy font-bold text-sm leading-snug">{session.title}</p>
          <p className="text-navy-64 text-xs mt-0.5">{session.type} · {session.duration}</p>
        </div>
      ))}
    </div>
  </div>
);
